<script>
import {notificationMethods, customerMethods, personMethods,productMethods, contractMethods , noteMethods, uploadMethods} from "@/state/helpers";
//import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import Cookies from "js-cookie";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Müşteri Detay",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      customer: {},
      productTransactions: [],
      title: "Müşteri Detay",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Müşteriler",
          href:"/products"
        },
        {
          text: "Müşteri Detay",
          active: true,
        },
      ],
      currentUser:JSON.parse(Cookies.get('user')),
      addSubmitted: false,
      editSubmitted: false,
      noteAddSubmitted:false,
      showModal: false,
      showNoteModal:false,
      paid:false,
      editModal: false,
      deleteModal: false,
      noteDeleteModal:false,
      noteDeleteId:'',
      editId: "",
      deleteId: "",
      customersLoaded:false,
      jointCustomerFilter:'',
      personsLoaded:false,
      formSelectPersons:[],
      productsLoaded:false,
      formSelectProducts:[],
      formSelectJointCustomers:[],
      selectedJointCustomer:{},
      selectedEditJointCustomer:{},
      quantityError:false,
      productId:0,
      totalRows: 1,
      page: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "createdAt",
      sortDesc: false,
      fields: [
        {
          key: "personId",
          label:'Plasiyer'
        },
        {
          key: "discountedAmount",
          label:'Tutar'
        },
        {
          key: "discountRate",
          label:'İndirim Oranı'
        },
        {
          key: "createdAt",
          label:'Oluşturulma Tarihi'
        },
        {
          key: "contractDate",
          label:'Evrak Tarihi'
        },
        {
          key: "deliveryTime",
          label:'Teslim Tarihi'
        },
        {
          key: "status",
          label:'Durumu'
        },
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      paymentFields: [
        {
          key: "installmentDate",
          label: "Ödeme Tarihi",
        },
        {
          key: "paymentDate",
          label: "Ödendiği Tarih",
        },
        {
          key: "amount",
          label: "Tutar",
        },
        {
          key: "pay",
          label: "Ödenmiş Tutar",
        },
        {
          key: "status",
          label: "Ödenme Durumu",
        },
      ],
      noteFields:[
        {
          key: "createdAt",
          label:'Oluşturulma Tarihi'
        },
        {
          key: "user.name",
          label:'Oluşturan'
        },
        {
          key: "note",
          label:'Not'
        },
        {
          key: "reminder",
          label:'Hatırlatma'
        },
        {
          key: "reminderDate",
          label:'Hatırlatma Tarihi'
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],

      addForm: {
        contractNumber:"",
        customerId:this.$route.params.customerId,
        jointCustomerId:"",
        personId:"",
        contractDate:"",
        deliveryTime:"",
        contractForm:"",
        products:[],
        payment:{
          totalAmount:"",
          discountRate:"",
          installment:"",
          startDate:""
        }
      },
      editForm: {
        contractNumber:"",
        customerId:this.$route.params.customerId,
        jointCustomerId:"",
        personId:"",
        contractDate:"",
        contractForm:"",
        deliveryTime:"",
        status:"",
        payment:{
          totalAmount:"",
          discountRate:"",
          installment:"",
          startDate:""
        }
      },
      noteAddForm:{
        note:'',
        reminder: false,
        reminderDate: null
      },
      payments:[],
      paymentsLoaded:false,
      notes:[],
      notesLoaded:false,
      notesPage: 1,
      imgLoading:false,
      editImgLoading:false
    };
  },
  validations: {
    addForm: {
      contractNumber:{required},
      customerId:{required},
      personId:{required},
      contractDate:{required},
      deliveryTime:{required},
      contractForm:{required},
      payment:{
        totalAmount:{required},
        discountRate:{required},
        installment:{required},
        startDate:{required}
      }
    },
    editForm: {
      completedStatus:{required},
      contractNumber:{required},
      customerId:{required},
      personId:{required},
      contractDate:{required},
      deliveryTime:{required},
      contractForm:{required},
      status:{required},
      payment:{
        totalAmount:{required},
        discountRate:{required},
        installment:{required},
        startDate:{required}
      }
    },
    noteAddForm:{
      note:{required}
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    }
  },
  watch:{
    page(newPage){
      this.getContracts(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        if(this.page===1){
          this.getContracts();
        }else{
          this.page=1;
        }
      }
    },
    jointCustomerFilter(newFilter){
      if (newFilter.length > 2) {
        this.getCustomersForFormSelect(newFilter)
      } else {
        this.formSelectJointCustomers = [];
      }
   },
  },
  mounted() {
    this.getCustomer()
    this.getPersonsForFormSelect()
    this.getProductsForFormSelect()
    this.getContracts();
    this.getNotes()
    this.getCustomerPayments()
  },
  methods: {
    ...contractMethods,
    ...customerMethods,
    ...productMethods,
    ...personMethods,
    ...notificationMethods,
    ...noteMethods,
    ...uploadMethods,
    handleReturnFromDetailPage() {
      // Müşteri listesi sayfasına geri dön
      this.$router.push({ path: '/customers?page=' + JSON.parse(localStorage.getItem('paginationInfo')).page });
    },
    getPagination(){
      return JSON.parse(localStorage.getItem('paginationInfo'))
    },
    onImageChange(e){
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload',files[0])
      data.append('folder','contracts')
      let addForm = this.addForm;
      this.imgLoading=true;
      this.uploadFile(data).then((res)=>{
        addForm.contractForm = res.url;
        this.imgLoading=false;
      })
    },

    onEditImageChange(e){
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload',files[0])
      data.append('folder','contracts')
      let editForm = this.editForm;
      this.editImgLoading=true;
      this.uploadFile(data).then((res)=>{
        editForm.contractForm = res.url;
        this.editImgLoading=false;
      })
    },

    getCustomerPayments(){
      this.paymentsLoaded=false
      this.fetchCustomerPayments({id: this.$route.params.customerId}).then(res=>{
        this.payments = res.docs
        this.paymentsLoaded=true
      })
    },

    getNotes(page=this.notesPage){
      this.notesLoaded=false
      this.fetchNotes({id: this.$route.params.customerId,page,limit:this.perPage}).then(res=>{
        this.notes = res
        this.notesLoaded=true
      })
    },

    getCustomer(){
      this.itemsLoaded=false
      this.fetchCustomer({id: this.$route.params.customerId}).then(res=>{
        this.customer = res
        this.itemsLoaded=true
      })
    },

    getCustomersForFormSelect(){
      let filter = {search:this.jointCustomerFilter}
      this.fetchCustomers({listType:'select',...filter}).then(res=>{
        this.formSelectJointCustomers = res.docs.filter(doc=>doc.id!=this.$route.params.customerId);
      })
    },

    getContracts(page=this.page){
      this.itemsLoaded=false;
      this.fetchContracts({page,limit:this.perPage,search:this.search,customerId: this.$route.params.customerId}).then(res=>{
        this.totalRows = res.total;
        this.items = res.docs
        this.itemsLoaded=true;
      })
    },

    getPersonsForFormSelect(){
      this.personsLoaded=false;
      this.fetchPersons({listType:'select'}).then(res=>{
        this.formSelectPersons = res.docs;
        this.addForm.personId = res.docs[0].id;
        this.personsLoaded=true;
      })
    },

    getProductsForFormSelect(){
      this.productsLoaded=false;
      this.fetchProducts({listType:'select'}).then(res=>{
        this.formSelectProducts = res.docs;
        // this.addForm.pr = res.docs[0].id;
        this.productsLoaded=true;
      })
    },

    filterUnusedProducts(){
      if(this.addForm.products.length>1){
        let selectedProducts = [...this.addForm.products]
        selectedProducts = selectedProducts.map(sP=>sP.id)
        return this.formSelectProducts.filter(formSelectProduct=>{
          if(!selectedProducts.includes(formSelectProduct.id)){
            return formSelectProduct;
          }
        })
      }else{
        return this.formSelectProducts
      }
    },

    addProductInstance(){
      if(this.formSelectProducts.length>this.productId) {
        this.addForm.products.push({productId: this.formSelectProducts[this.productId].id, quantity: ''})
        this.productId += 1;
      }
    },
    removeElement(id){
      this.addForm.products = this.addForm.products.filter(element=>{
        return id!==element.productId
      })
      this.productId-=1;
    },

    handleSubmit() {
      this.addSubmitted = true;
      for(let i=0;i<this.addForm.products.length;i++){
        if(!this.addForm.products[i].quantity){
          this.quantityError=true;
          break;
        }else{
          this.quantityError=false;
        }
      }
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid || this.addForm.products.length<1 || this.quantityError || isNaN(this.addForm.payment.totalAmount) || isNaN(this.addForm.payment.discountRate) || isNaN(this.addForm.payment.installment)
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.addForm))
        if(!data.jointCustomerId){
          data.jointCustomerId = null
        }

        this.createContract(data).then(()=>{
          this.toastMessage="Evrak başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getContracts();
          this.getCustomerPayments()
          this.addForm.name = "";
          this.addForm.contractname = "";
          this.addForm.email = "";
          this.addForm.password = "";
          this.addForm.role = "contract";
          this.addForm.status = true;
        })
      }
    },

    handleEditSubmit() {
      /* eslint-disable no-console */
      console.log("update submit formundasın")
      this.editSubmitted = true;
      this.$v.editForm.$touch();

      if (this.editForm.completedStatus === "") {
        this.editForm.completedStatus = false;
      }

      if (
          this.$v.editForm.$invalid || isNaN(this.editForm.payment.totalAmount) || isNaN(this.editForm.payment.discountRate) || isNaN(this.editForm.payment.installment)
      ) {
        return;
      } else {

        let data = JSON.parse(JSON.stringify(this.editForm))
        if(!data.jointCustomerId){
          data.jointCustomerId = null
        }
        if(this.paid){
          delete data.payment
        }

        this.updateContract({id:this.editId,data}).then(()=>{
          this.toastMessage="Evrak başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getContracts();
          this.getCustomerPayments()
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteContract(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Evrak başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getContracts();
        this.getCustomerPayments()
      })
    },

    handleNoteSubmit(){
      this.noteAddSubmitted = true;
      this.$v.noteAddForm.$touch();
      if (
          this.$v.noteAddForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.noteAddForm))
        data.customerId = this.$route.params.customerId;
       this.createNote(data).then(()=>{
          this.toastMessage="Not başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showNoteModal = false;
          this.getNotes();
          this.noteAddForm.note = "";
          this.noteAddForm.reminder = false;
          this.noteAddForm.reminderDate = null;
        })
      }
    },
    handleNoteDeleteSubmit(){
      this.deleteNote(this.noteDeleteId).then(()=>{
        this.noteDeleteModal = false;
        this.toastMessage="Not başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getNotes();
      })
    },

    openAdd(){
      this.jointCustomerFilter=''
      this.showModal=true;
    },

    openEdit(contract) {
      this.paid=false;
      contract.payments.map(payment=>{
        if(payment.status==1){
          this.paid=true;
        }
      })
      this.jointCustomerFilter=''
      this.editForm.customerId=contract.customerId._id
      if(contract.jointCustomerId){
        this.editForm.jointCustomerId=contract.jointCustomerId._id
        this.selectedEditJointCustomer=contract.jointCustomerId
      }
      this.editForm.completedStatus = contract.completedStatus;
      this.editForm.contractNumber=contract.contractNumber;
      this.editForm.contractForm=contract.contractForm;
      this.editForm.personId=contract.personId._id
      this.editForm.contractDate=contract.contractDate.split('T')[0]
      this.editForm.deliveryTime=contract.deliveryTime.split('T')[0]
      this.editForm.status = contract.status;
      this.editForm.payment.totalAmount = contract.totalAmount;
      this.editForm.payment.discountRate = contract.discountRate;
      this.editForm.payment.installment = contract.payments.length;
      this.editForm.payment.startDate = contract.payments[0].installmentDate.split('T')[0]
      this.editId = contract.id;
      this.editModal = true;
    },
    openDelete(contract) {
      this.deleteId = contract.id;
      this.deleteModal = true;
    },
    openNoteDelete(note) {
      this.noteDeleteId = note.id;
      this.noteDeleteModal = true;
    },
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    }
  },
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12 d-flex justify-content-start align-items-center mb-3">
        <div class="">
          <button @click="handleReturnFromDetailPage" class="btn btn-info ms-auto mb-2"><i class="fas fa-arrow-left me-2"></i>Geri Dön</button>
        </div>
      </div>
    </div>


    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Adı :</th>
                    <td>{{customer.name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tc Numarası :</th>
                    <td>{{customer.tcNumber}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Email :</th>
                    <td>{{customer.email}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Adresi :</th>
                    <td>
                      {{customer.address}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Aile Adresi :</th>
                    <td>{{customer.familyAddress}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Site :</th>
                    <td>{{customer.site.name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Üniversitesi :</th>
                    <td>{{customer.university}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Bölümü :</th>
                    <td>{{customer.section}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Telefon1 :</th>
                    <td>{{customer.phone1}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Telefon2 :</th>
                    <td>{{customer.phone2}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Aile Telefonu :</th>
                    <td>{{customer.familyPhone}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notesLoaded" class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Notlar</h5>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showNoteModal=true"
                >
                  Not Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="notes"
                  :fields="noteFields"
                  responsive="sm"
              >
                <template v-slot:cell(createdAt)="data">
                  {{data.item.createdAt| formatDate}}
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      class="btn btn-danger d-flex py-2"
                      @click="openNoteDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(reminder)="data">
                  <td v-if="data.item.reminder">
                    <span class="badge badge-pill badge-soft-warning font-size-14">Var</span>
                  </td>
                  <td v-else class="align-middle">
                    <span class="badge badge-pill badge-soft-danger font-size-14">Yok</span>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Evraklar</h5>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openAdd"
                >
                  Evrak Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
                <template v-slot:cell(customerId)="data">
                  {{data.item.customerId.name}}
                </template>
                <template v-slot:cell(discountedAmount)="data">
                  {{moneyFormat(data.item.discountedAmount)}}
                </template>
                <template v-slot:cell(installmentAmount)="data">
                  {{moneyFormat(data.item.installmentAmount)}}
                </template>
                <template v-slot:cell(personId)="data">
                  {{data.item.personId.name}}
                </template>
                <template v-slot:cell(discountRate)="data">
                  {{data.item.discountRate}}%
                </template>
                <template v-slot:cell(createdAt)="data">
                  {{data.item.createdAt| formatDate}}
                </template>
                <template v-slot:cell(contractDate)="data">
                  {{data.item.contractDate| formatDate}}
                </template>
                <template v-slot:cell(deliveryTime)="data">
                  {{data.item.deliveryTime| formatDate}}
                </template>
                <template v-slot:cell(status)="data">
                  <td v-if="data.item.completedStatus==1">
                    <span class="badge badge-pill badge-soft-warning font-size-14">Tamamlandı</span>
                  </td>
                  <td v-else-if="data.item.status==1" class="align-middle">
                    <span class="badge badge-pill badge-soft-success font-size-14">Aktif</span>
                  </td>
                  <td v-else class="align-middle">
                    <span class="badge badge-pill badge-soft-danger font-size-14">Pasif</span>
                  </td>
                </template>
                <template v-slot:cell(detail)="data">
                  <button
                      class="btn btn-info d-flex py-2"
                      @click= "$router.push({name:'contractDetail',params:{contractId: data.item.id}})"
                  >
                    <i :class="`bx bxs-detail bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="paymentsLoaded" class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Ödemeler</h5>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="payments"
                  :fields="paymentFields"
                  responsive="sm"
              >
                <template v-slot:cell(installmentDate)="data">
                  {{data.item.installmentDate| formatDate}}
                </template>
                <template v-slot:cell(paymentDate)="data">
                  {{data.item.paymentDate| formatDate}}
                </template>
                <template v-slot:cell(amount)="data">
                  {{moneyFormat(data.item.amount)}}
                </template>
                <template v-slot:cell(pay)="data">
                  {{moneyFormat(data.item.pay)}}
                </template>
                <template v-slot:cell(status)="data">
                  <td v-if="data.item.status==1" class="align-middle">
                    <span class="badge badge-pill badge-soft-success font-size-13">Ödendi</span>
                  </td>
                  <td v-else class="align-middle">
                    <span class="badge badge-pill badge-soft-danger font-size-13">Ödenmedi</span>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="Evrak Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="contractNumber">Kayıt Numarası</label>
                <input
                    id="contractNumber"
                    type="text"
                    v-model="addForm.contractNumber"
                    class="form-control"
                    placeholder="Kayıt numarası giriniz"
                    :class="{
                      'is-invalid': addSubmitted && $v.addForm.contractNumber.$error,
                    }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.contractNumber.required"
                    class="invalid-feedback"
                >
                  Kayıt numarası girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="customerId">Müşteri</label>
                <b-form-input
                    :disabled="true"
                    id="customerId"
                    type="text"
                    :placeholder="customer.name"
                ></b-form-input>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="jointCustomerId">Müşterek</label>
                <b-dropdown :style="{border:'1px solid #ced4da',textAlign:'left'}" class=" d-flex customSelect" :text="addForm.jointCustomerId ? selectedJointCustomer.name : 'Müşterek yok'"  variant="text-dark">
                  <form>
                    <input v-model="jointCustomerFilter" type="text" :style="{borderTop:'none'}"  class="dropdown-item" placeholder="ara...">
                  </form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item class="w-100" @click="()=>{
                    selectedJointCustomer={}
                    addForm.jointCustomerId=''
                  }">
                    Müşterek yok
                  </b-dropdown-item>
                  <b-dropdown-item class="w-100" @click="()=>{
                    selectedJointCustomer=customer
                    addForm.jointCustomerId=customer.id
                  }" :key="customer.id" v-for="customer in formSelectJointCustomers">
                    {{customer.name}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="personId">Plasiyer</label>
                <select name="personId"
                        v-model="addForm.personId"
                        class="form-control">
                  <option
                      v-for="person in formSelectPersons"
                      :key="person.id"
                      :value="person.id"
                  >{{person.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="contractDate">Evrak Tarihi</label>
                <b-form-input
                    v-model="addForm.contractDate"
                    id="contractDate"
                    type="date"
                    :class="{
                      'is-invalid': addSubmitted && $v.addForm.contractDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="addSubmitted && $v.addForm.contractDate.$error"
                    class="invalid-feedback"
                >
                  Evrak Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="deliveryTime">Teslim Tarihi</label>
                <b-form-input
                    v-model="addForm.deliveryTime"
                    id="deliveryTime"
                    type="date"
                    :class="{
                      'is-invalid': addSubmitted && $v.addForm.deliveryTime.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="addSubmitted && $v.addForm.deliveryTime.$error"
                    class="invalid-feedback"
                >
                  Teslim Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="contractForm" class="form-label">Evrak Görseli</label>
                <input
                    type="file"
                    id="contractForm"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                      'is-invalid': addSubmitted && !addForm.contractForm,
                }"
                />
              </div>
              <div
                  v-if="addSubmitted && !addForm.contractForm"
                  class="invalid-feedback"
              >
                Görsel girilmesi gerekli bir alandır.
              </div>
            </div>
            <div class="col-6 d-flex justify-content-start mb-3">
              <b-spinner v-if="imgLoading" class="m-5" variant="primary"></b-spinner>
              <img v-else :class="addForm.contractForm ? 'd-block' : 'd-none'" class="w-50" id="imgDisplay" :src="addForm.contractForm" alt="listImage">
            </div>
            <div class="col-12">
              <div>
                <h6>Ödeme Bilgileri</h6>
                <div class="col-12 d-flex justify-content-center">
                  <div class="row p-2 col-12 mb-2"
                       :style="{border:`1px solid #ced4da` }">
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="totalAmount">Toplam Tutar</label>
                        <input
                            id="totalAmount"
                            type="text"
                            v-model="addForm.payment.totalAmount"
                            class="form-control"
                            placeholder="Tutar giriniz"
                            :class="{
                      'is-invalid': addSubmitted && ($v.addForm.payment.totalAmount.$error || isNaN(addForm.payment.totalAmount)),
                    }"
                        />
                        <div
                            v-if="addSubmitted && !$v.addForm.payment.totalAmount.required"
                            class="invalid-feedback"
                        >
                          Toplam Tutar girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="addSubmitted && $v.addForm.payment.totalAmount.required && isNaN(addForm.payment.totalAmount)"
                            class="invalid-feedback"
                        >
                          Toplam Tutar alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="discountRate">İndirim Oranı</label>
                        <input
                            id="discountRate"
                            type="text"
                            v-model="addForm.payment.discountRate"
                            class="form-control"
                            placeholder="İndirim oranı giriniz"
                            :class="{
                      'is-invalid': addSubmitted && ($v.addForm.payment.discountRate.$error || isNaN(addForm.payment.discountRate)),
                    }"
                        />
                        <div
                            v-if="addSubmitted && !$v.addForm.payment.discountRate.required"
                            class="invalid-feedback"
                        >
                          İndirim oranı girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="addSubmitted && $v.addForm.payment.discountRate.required && isNaN(addForm.payment.discountRate)"
                            class="invalid-feedback"
                        >
                          İndirim oranı alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="installment">Taksit Adeti</label>
                        <input
                            id="installment"
                            type="text"
                            v-model="addForm.payment.installment"
                            class="form-control"
                            placeholder="Adet giriniz"
                            :class="{
                      'is-invalid': addSubmitted && ($v.addForm.payment.installment.$error || isNaN(addForm.payment.installment)),
                    }"
                        />
                        <div
                            v-if="addSubmitted && !$v.addForm.payment.installment.required"
                            class="invalid-feedback"
                        >
                          Taksit adeti girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="addSubmitted && $v.addForm.payment.installment.required && isNaN(addForm.payment.installment)"
                            class="invalid-feedback"
                        >
                          İndirim oranı alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="startDate">Ödeme Başlangıcı</label>
                        <b-form-input
                            v-model="addForm.payment.startDate"
                            id="startDate"
                            type="date"
                            :class="{
                        'is-invalid': addSubmitted && $v.addForm.payment.startDate.$error,
                      }"
                        ></b-form-input>
                        <div
                            v-if="addSubmitted && $v.addForm.payment.startDate.$error"
                            class="invalid-feedback"
                        >
                          Teslim Tarihi girilmesi gerekli bir alandır.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div  :class="{
                      'is-invalid': addSubmitted && (addForm.products.length<1 || quantityError),
                    }">
                <h6>Evrak Ürünleri {{`(${addForm.products.length})`}} </h6>
                <div class="col-12" >

                  <div v-for="product in addForm.products"
                       :key="product.productId"
                       class="p-2 col-12 mb-2"
                       :style="{border:`1px solid #ced4da` }"
                  >
                    <div class="pt-2">
                      <!-- block form tab when its selected -->

                      <div class="d-flex gap-2 align-items-center">
                        <div class="col-9 row">
                          <form action="">
                            <label for="product">Ürün</label>
                            <select
                                :ref="product.productId"
                                name="product"
                                v-model="addForm.products[addForm.products.indexOf(product)].productId"
                                class="form-control">
                              <option
                                  v-for="product in filterUnusedProducts()"
                                  :key="product.id"
                                  :value="product.id"
                              >{{product.name}}</option>
                            </select>
                          </form>
                        </div>
                        <div class="col-3 row">
                          <form action="">
                            <label for="quantity">Adet</label>
                            <input
                                :ref="product.quantity"
                                id="heading"
                                type="text"
                                v-model="addForm.products[addForm.products.indexOf(product)].quantity"
                                class="form-control col-9"
                            />
                          </form>
                        </div>
                        <div @click="removeElement(product.productId)" :style="{cursor:'pointer'}">
                          <i class="bx bxs-trash-alt" :style="{fontSize:'18px'}"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="addForm.products.length>0" @click="addProductInstance" :style="{border:'1px solid #ced4da',cursor:'pointer'}" class="d-flex align-items-center justify-content-center gap-2 py-2">
                  <i class="bx bx-plus" :style="{fontSize:'20px'}"></i>
                  <h6 class="m-0">Ürün Ekle</h6>
                </div>
                <div v-if="addForm.products.length<1" @click="addProductInstance" :style="{border:'1px solid #ced4da',cursor:'pointer'}" class="d-flex flex-column align-items-center gap-2 py-4">
                  <i class="bx bxs-plus-circle" :style="{fontSize:'30px'}"></i>
                  <h6 class="m-0">Evrağa Ürün Ekle</h6>
                </div>
              </div>
              <div
                  v-if="addSubmitted && addForm.products.length<1"
                  class="invalid-feedback "
              >
                Ürün girilmesi gereken bir alandır.
              </div>
              <div
                  v-if="addSubmitted && quantityError"
                  class="invalid-feedback "
              >
                Lütfen ürün miktarlarını belirtiniz.
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Evrak Ekle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="Evrak Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <b-form-checkbox
                    class="form-check"
                    id="completedStatus"
                    v-model="editForm.completedStatus"
                >
                  Tamamlanma Durumu
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="contractNumber">Kayıt Numarası</label>
                <input
                    id="contractNumber"
                    type="text"
                    v-model="editForm.contractNumber"
                    class="form-control"
                    placeholder="Kayıt numarası giriniz"
                    :class="{
                      'is-invalid': editSubmitted && $v.editForm.contractNumber.$error,
                    }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.contractNumber.required"
                    class="invalid-feedback"
                >
                  Kayıt numarası girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="customerId">Müşteri</label>
                <b-form-input
                    :disabled="true"
                    id="customerId"
                    type="text"
                    :placeholder="customer.name"
                ></b-form-input>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="jointCustomerId">Müşterek</label>
                <b-dropdown :style="{border:'1px solid #ced4da',textAlign:'left'}" class=" d-flex customSelect" :text="editForm.jointCustomerId ? selectedEditJointCustomer.name : 'Müşterek yok'"  variant="text-dark">
                  <form>
                    <input v-model="jointCustomerFilter" type="text" :style="{borderTop:'none'}"  class="dropdown-item" placeholder="ara...">
                  </form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item class="w-100" @click="()=>{
                    selectedEditJointCustomer={}
                    editForm.jointCustomerId=''
                  }">
                    Müşterek yok
                  </b-dropdown-item>
                  <b-dropdown-item class="w-100" @click="()=>{
                    selectedEditJointCustomer=customer
                    editForm.jointCustomerId=customer.id
                  }" :key="customer.id" v-for="customer in formSelectJointCustomers">
                    {{customer.name}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="personId">Plasiyer</label>
                <select name="personId"
                        v-model="editForm.personId"
                        class="form-control">
                  <option
                      v-for="person in formSelectPersons"
                      :key="person.id"
                      :value="person.id"
                  >{{person.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="contractDate">Evrak Tarihi</label>
                <b-form-input
                    v-model="editForm.contractDate"
                    id="contractDate"
                    type="date"
                    :class="{
                      'is-invalid': editSubmitted && $v.editForm.contractDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="editSubmitted && $v.editForm.contractDate.$error"
                    class="invalid-feedback"
                >
                  Evrak Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="deliveryTime">Teslim Tarihi</label>
                <b-form-input
                    v-model="editForm.deliveryTime"
                    id="deliveryTime"
                    type="date"
                    :class="{
                      'is-invalid': editSubmitted && $v.editForm.deliveryTime.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="editSubmitted && $v.editForm.deliveryTime.$error"
                    class="invalid-feedback"
                >
                  Teslim Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="status">Aktiflik Durumu</label>
                <select name="status"
                        v-model="editForm.status"
                        class="form-control">
                  <option :value="true">Aktif</option>
                  <option :value="false">Pasif</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="contractForm" class="form-label">Evrak Görseli</label>
                <input
                    type="file"
                    id="contractForm"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                      'is-invalid': editSubmitted && !editForm.contractForm,
                }"
                />
              </div>
              <div
                  v-if="editSubmitted && !editForm.contractForm"
                  class="invalid-feedback"
              >
                Görsel girilmesi gerekli bir alandır.
              </div>
            </div>
            <div class="col-6"></div>
            <div class="col-6 d-flex justify-content-start mb-3">
              <b-spinner v-if="editImgLoading" class="m-5" variant="primary"></b-spinner>
              <img v-else :class="editForm.contractForm ? 'd-block' : 'd-none'" class="w-50" id="imgDisplay" :src="editForm.contractForm" alt="listImage">
            </div>
            <div class="col-12">
              <div>
                <h6>Ödeme Bilgileri</h6>
                <div class="col-12 d-flex justify-content-center">
                  <div class="row p-2 col-12 mb-2"
                       :style="{border:`1px solid #ced4da` }">
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="totalAmount">Toplam Tutar</label>
                        <input
                            :disabled="paid ? true : false"
                            id="totalAmount"
                            type="text"
                            v-model="editForm.payment.totalAmount"
                            class="form-control"
                            placeholder="Tutar giriniz"
                            :class="{
                      'is-invalid': editSubmitted &&( $v.editForm.payment.totalAmount.$error || isNaN(editForm.payment.totalAmount)),
                    }"
                        />
                        <div
                            v-if="editSubmitted && !$v.editForm.payment.totalAmount.required"
                            class="invalid-feedback"
                        >
                          Toplam Tutar girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="editSubmitted && $v.editForm.payment.totalAmount.required && isNaN(editForm.payment.totalAmount)"
                            class="invalid-feedback"
                        >
                          Toplam tutar alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="discountRate">İndirim Oranı</label>
                        <input
                            :disabled="paid ? true : false"
                            id="discountRate"
                            type="text"
                            v-model="editForm.payment.discountRate"
                            class="form-control"
                            placeholder="İndirim oranı giriniz"
                            :class="{
                      'is-invalid': editSubmitted && ($v.editForm.payment.discountRate.$error || isNaN(editForm.payment.discountRate)),
                    }"
                        />
                        <div
                            v-if="editSubmitted && !$v.editForm.payment.discountRate.required"
                            class="invalid-feedback"
                        >
                          İndirim oranı girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="editSubmitted && $v.editForm.payment.discountRate.required && isNaN(editForm.payment.discountRate)"
                            class="invalid-feedback"
                        >
                          İndirim oranı alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="installment">Taksit Adeti</label>
                        <input
                            :disabled="paid ? true : false"
                            id="installment"
                            type="text"
                            v-model="editForm.payment.installment"
                            class="form-control"
                            placeholder="Adet giriniz"
                            :class="{
                      'is-invalid': editSubmitted && ($v.editForm.payment.installment.$error || isNaN(editForm.payment.installment)),
                    }"
                        />
                        <div
                            v-if="editSubmitted && !$v.editForm.payment.installment.required"
                            class="invalid-feedback"
                        >
                          Taksit adeti girilmesi gerekli bir alandır.
                        </div>
                        <div
                            v-if="editSubmitted && $v.editForm.payment.installment.required && isNaN(editForm.payment.installment)"
                            class="invalid-feedback"
                        >
                          Taksit adeti alanına sayı girilmelidir.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <label for="startDate">Ödeme Başlangıcı</label>
                        <b-form-input
                            :disabled="paid ? true : false"
                            v-model="editForm.payment.startDate"
                            id="startDate"
                            type="date"
                            :class="{
                        'is-invalid': editSubmitted && $v.editForm.payment.startDate.$error,
                      }"
                        ></b-form-input>
                        <div
                            v-if="editSubmitted && $v.editForm.payment.startDate.$error"
                            class="invalid-feedback"
                        >
                          Teslim Tarihi girilmesi gerekli bir alandır.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Evrak Düzenle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu sözleşmeyi silmek istediğinize emin misiniz? Silinmiş sözleşmelerı geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal size="lg" v-if="notesLoaded" v-model="showNoteModal" title="Not Ekle" hide-footer>
        <form @submit.prevent="handleNoteSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="note">Not</label>
                <textarea
                    v-model="noteAddForm.note"
                    class="form-control"
                    :class="{'is-invalid': noteAddSubmitted && $v.noteAddForm.note.$error,}"
                    rows="3"
                    col="5"
                    name="note"
                ></textarea>
                <div
                    v-if="noteAddSubmitted && $v.noteAddForm.note.$error"
                    class="invalid-feedback"
                >
                  Not girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="field" class="me-2">Hatırlatma</label>
                <input
                    id="field"
                    type="checkbox"
                    v-model="noteAddForm.reminder"
                    class="form-check-input"
                />
              </div>
            </div>
            <div class="col-6" v-if="noteAddForm.reminder">
              <div class="mb-3">
                <label for="birthdate">Hatırlatma Tarihi</label>
                <b-form-input
                    v-model="noteAddForm.reminderDate"
                    id="birthdate"
                    type="date"
                ></b-form-input>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showNoteModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Not Ekle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="noteDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu notu silmek istediğinize emin misiniz? Silinmiş notları geri alamazsınız.
              </p>

              <form @submit.prevent="handleNoteDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.customSelect .dropdown-menu{
  width:100% !important;
}
.customSelect .btn{
  text-align: left;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
